import { Box, Fade, Tab, Tabs } from '@mui/material';
import { useCallback, useState } from 'react';
import { baseNewAndDetailClasses } from '../../../utility';
import _BucketsTab from './SubTabs/_BucketsTab';
import _HarvestsTab from './SubTabs/_HarvestsTab';
import _PackagesSubTab from './SubTabs/_PackagesSubTab';

const defaultTab = 'harvests';

const tabEntityMap = [
  { key: 'harvests', label: 'Harvests' },
  { key: 'buckets', label: 'Buckets' },
  { key: 'packages', label: 'Packages' },
];

const _PackagesTab = props => {
  const { packages = [], currDarkThemeClass = '', cropPlanPerms, values: parentValues, handleSetValues, handleErrorWithFeedback } = props;

  const [tab, setTab] = useState({ currentTab: defaultTab });

  const rTabProps = {
    className: `${baseNewAndDetailClasses?.tab} ${currDarkThemeClass}`,
  };

  const handleSetTabValues = useCallback((prop, value) => setTab(state => ({ ...state, [prop]: value })), []);

  const handleSetTabValue = (_, value) => handleSetTabValues('currentTab', value);

  const tabsList = tabEntityMap.map((e, i) => <Tab key={i} value={e.key} label={e.label} {...rTabProps} />);

  const rTabsProps = {
    className: `${baseNewAndDetailClasses?.tabs} ${currDarkThemeClass} roomDetailTabsContent`,
    onChange: handleSetTabValue,
    value: tab?.currentTab ?? defaultTab,
  };

  const renderTabContent = () => {
    switch (tab?.currentTab) {
      case 'harvests':
        return <_HarvestsTab currDarkThemeClass={currDarkThemeClass} {...props} />;
      case 'buckets':
        return <_BucketsTab currDarkThemeClass={currDarkThemeClass} {...props} />;
      case 'packages':
        return <_PackagesSubTab packages={packages} currDarkThemeClass={currDarkThemeClass} {...props} />;
      default:
        return <_BucketsTab currDarkThemeClass={currDarkThemeClass} {...props} />;
    }
  };

  return (
    <Fade in={true} timeout={1000}>
      <Box>
        <Tabs {...rTabsProps} style={{ paddingBottom: '20px' }}>
          {tabsList}
        </Tabs>
        {renderTabContent()}
      </Box>
    </Fade>
  );
};

export default _PackagesTab;
